namespace $.$$ {
	export class $eve_app_page_components_slider extends $.$eve_app_page_components_slider {}
}
